import { InjectionToken } from '@angular/core';
import { GiftCardsDatalayerService } from '@core/services/ib-gift-cards-datalayer-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils';

export const AJSGiftCardsDatalayerService = new InjectionToken<GiftCardsDatalayerService>('GiftCardsDatalayerService');
export const AJSGiftCardsDatalayerServiceProvider = upgradeAJSServiceProvider('GiftCardsDatalayerService', AJSGiftCardsDatalayerService);

export interface GiftCardsDatalayerServiceType extends GiftCardsDatalayerService {}